/* import __COLOCATED_TEMPLATE__ from './guidance-search.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import templateOnly from '@ember/component/template-only';

interface Args {
  searchFunction: (event: Event) => void;
  searchTerm: string | undefined;
  resetSearch: () => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

const GuidanceSearch = templateOnly<Signature>();

export default GuidanceSearch;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Guidance::GuidanceSearch': typeof GuidanceSearch;
    'ai-agent/guidance/guidance-search': typeof GuidanceSearch;
  }
}
